(function() {
  const accountLink = document.getElementById('account-link');
  const submenu = document.getElementById('fender-header-account-submenu');
  let hideTimeout;

  function showSubmenu() {
    clearTimeout(hideTimeout);
    submenu.style.display = 'block';
    accountLink.style.backgroundColor = '#f5f5f5';
    accountLink.style.borderRadius = '100%';
  }

  function hideSubmenu() {
    hideTimeout = setTimeout(() => {
      submenu.style.display = 'none';
      accountLink.style.backgroundColor = '';
      accountLink.style.borderRadius = '';
    }, 200);
  }

  // Desktop event handlers
  function desktopMouseEnterHandler() {
    showSubmenu();
  }
  function desktopMouseLeaveHandler() {
    hideSubmenu();
  }

  // Mobile event handlers
  function mobileClickHandler(e) {
    // Toggle submenu on tap: if not visible, show it; if visible, hide it.
    if (submenu.style.display !== 'block') {
      e.preventDefault();
      showSubmenu();
    } else {
      e.preventDefault();
      hideSubmenu();
    }
  }
  function mobileDocumentClickHandler(e) {
    if (!accountLink.contains(e.target) && !submenu.contains(e.target)) {
      hideSubmenu();
    }
  }

  // Track current mode to avoid duplicate event bindings.
  let currentMode = '';

  function setupListeners() {
    const isMobile = window.matchMedia('(pointer: coarse)').matches;
    if (isMobile && currentMode !== 'mobile') {
      // Remove any desktop listeners
      accountLink.removeEventListener('mouseenter', desktopMouseEnterHandler);
      accountLink.removeEventListener('mouseleave', desktopMouseLeaveHandler);
      submenu.removeEventListener('mouseenter', desktopMouseEnterHandler);
      submenu.removeEventListener('mouseleave', desktopMouseLeaveHandler);
      // Add mobile (click-based) listeners
      accountLink.addEventListener('click', mobileClickHandler);
      document.addEventListener('click', mobileDocumentClickHandler);
      currentMode = 'mobile';
    } else if (!isMobile && currentMode !== 'desktop') {
      // Remove mobile listeners if present
      accountLink.removeEventListener('click', mobileClickHandler);
      document.removeEventListener('click', mobileDocumentClickHandler);
      // Add desktop (hover-based) listeners
      accountLink.addEventListener('mouseenter', desktopMouseEnterHandler);
      accountLink.addEventListener('mouseleave', desktopMouseLeaveHandler);
      submenu.addEventListener('mouseenter', desktopMouseEnterHandler);
      submenu.addEventListener('mouseleave', desktopMouseLeaveHandler);
      currentMode = 'desktop';
    }
  }

  // Initial setup based on the current device input.
  setupListeners();

  // Listen for changes in the media query to update event listeners dynamically.
  const mq = window.matchMedia('(pointer: coarse)');
  if (mq.addEventListener) {
    mq.addEventListener('change', setupListeners);
  } else if (mq.addListener) {
    mq.addListener(setupListeners);
  }
})();
